<template>
  <div>
    <div>
      <div class="d-flex">
        <div class="title-location header-title px-2" :style="{ width: `calc(${descriptionColumn}px + 332px)` }">
          BÁN {{ type === 'mass' ? 'BUÔN' : 'LẺ' }}
        </div>
        <div class="content-location error--text" :style="{ width: '96px' }">
          {{ getTotalQuantityOfCity('storedQuantity') }}
        </div>
        <div class="content-location error--text" :style="{ width: '96px' }">
          {{ getTotalQuantityOfCity('importedQuantity') }}
        </div>
        <div class="content-location error--text" :style="{ width: '96px' }">
          {{ getTotalQuantityOfCity('exportedQuantity') }}
        </div>
        <div class="content-location error--text" :style="{ width: '116px' }">
          {{ getTotalQuantityOfCity('totalStoredQuantity') }}
        </div>
        <div class="content-location error--text" :style="{ width: '106px' }">
          {{ getTotalQuantityOfCity('totalSupplierStoredQuantity') }}
        </div>
        <div class="content-location error--text" :style="{ width: '106px' }">
          {{ getTotalQuantityOfCity('totalSystemStoredQuantity') }}
        </div>
      </div>
      <div class="divider-custom my-4"></div>
      <div v-if="Object.keys(listAreas).length">
        <div v-for="(area, aidx) in Object.keys(listAreas)" :key="area">
          <v-divider class="my-2" v-if="aidx !== 0" />
          <div class="d-flex">
            <div class="title-location" :style="{ width: `calc(${descriptionColumn}px + 332px)` }">
              <div class="pl-4">{{ convertNameLocation(area) }}</div>
            </div>
            <div class="content-location" :style="{ width: '96px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'storedQuantity') }}
            </div>
            <div class="content-location" :style="{ width: '96px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'importedQuantity') }}
            </div>
            <div class="content-location" :style="{ width: '96px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'exportedQuantity') }}
            </div>
            <div class="content-location" :style="{ width: '116px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalStoredQuantity') }}
            </div>
            <div class="content-location" :style="{ width: '106px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSupplierStoredQuantity') }}
            </div>
            <div class="content-location" :style="{ width: '106px' }">
              {{ getTotalQuantityOfArea(listAreas[area], 'totalSystemStoredQuantity') }}
            </div>
          </div>
          <div v-for="(inventory, invenIdx) in listAreas[area]" :key="invenIdx">
            <div class="d-flex mt-2">
              <div class="title-location" :style="{ width: `calc(${descriptionColumn}px + 332px)` }">
                <div class="pl-8">{{ inventory.name }}</div>
              </div>
              <div class="content-location" :style="{ width: '96px' }">{{ inventory.storedQuantity || 0 }}</div>
              <div class="content-location" :style="{ width: '96px' }">{{ inventory.importedQuantity || 0 }}</div>
              <div class="content-location" :style="{ width: '96px' }">{{ inventory.exportedQuantity || 0 }}</div>
              <div class="content-location" :style="{ width: '116px' }">{{ inventory.totalStoredQuantity || 0 }}</div>
              <div class="content-location" :style="{ width: '106px' }">
                {{ inventory.totalSupplierStoredQuantity || 0 }}
              </div>
              <div class="content-location" :style="{ width: '106px' }">
                {{ inventory.totalSystemStoredQuantity || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { groupBy, sum, get } from 'lodash'
export default {
  name: 'ListLocationsImport',
  props: {
    displayType: String,
    type: String,
    model: Object,
    descriptionColumn: {
      type: Number,
      default: null
    }
  },
  methods: {
    ...mapActions({
      fetchReportsWithSaleArea: 'productModels/fetchReportsWithSaleArea'
    }),
    onChangeImportQuantity(quantity, inventory) {
      if (!quantity || Number(quantity) < 0) this.$alert.warn('Nhập sai định dạng')
      this.listAreas[inventory.location] = this.listAreas[inventory.location].map(i => {
        if (i.id === inventory.id) {
          return {
            ...i,
            orderedQuantity: Number(quantity)
          }
        } else return i
      })
      this.$emit('change', { saleArea: inventory.id, quantity: Number(quantity) })
    },
    getTotalQuantityOfArea(val, type) {
      const listQuantity = val.filter(i => i.category === this.type).map(i => i[type] || 0)
      return sum(listQuantity)
    },
    getTotalQuantityOfCity(type) {
      let listAreasArr = []
      Object.keys(this.listAreas).forEach(key => {
        listAreasArr = [...listAreasArr, ...this.listAreas[key]]
      })
      const listQuantity = listAreasArr.filter(i => i.category === this.type).map(i => i[type] || 0)
      return sum(listQuantity)
    },
    convertNameLocation(val) {
      return this.$utils.convertCodeLocationToName(val)
    }
  },
  watch: {
    model: {
      async handler(val) {
        if (val) {
          let params = {
            id: val.id,
            category: this.type
          }
          if (val.date) {
            params.date = val.date
          }
          const res = await this.fetchReportsWithSaleArea(params)
          this.listAreas = groupBy(
            res.filter(v => v.category === this.type),
            'location'
          )
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      listAreas: {},
      listAreasArr: [],
      get
    }
  }
}
</script>
<style scoped>
.custom-input {
  text-align: right;
  width: 100%;
  border: 1px solid;
  padding-right: 4px;
}

.title-location {
  text-align: start;
  padding-left: 4px;
  font-size: 14px;
  color: #3e3e3c;
}

.content-location {
  /* width: 15%; */
  padding: 0 8px;
  text-align: end;
  font-size: 14px;
  color: #3e3e3c;
}

.header-title {
  font-size: 16px;
  font-weight: 500;
}

.divider-custom {
  /* width: 100%; */
  background: black;
  height: 1px;
}
</style>
